import type { RateLimitSource } from '@nadoutong/contracts';
import { useT } from '../../i18n/index.ts';
import type { I18nKey } from '../../i18n/index.ts';
import { Chip } from '../../ui/index.ts';
import type { ChipTone } from '../../ui/index.ts';

export const SOURCE_KEY: Record<RateLimitSource, I18nKey> = {
  org_sku: 'quotas.editor.source.org_sku',
  org_all: 'quotas.editor.source.org_all',
  sku: 'quotas.editor.source.sku',
  global: 'quotas.editor.source.global',
  none: 'quotas.editor.source.none',
};

const SOURCE_TONE: Record<RateLimitSource, ChipTone> = {
  org_sku: 'signal',
  org_all: 'warn',
  sku: 'ok',
  global: 'neutral',
  none: 'neutral',
};

export function SourceChip({
  source,
  testId,
}: {
  readonly source: RateLimitSource;
  readonly testId?: string;
}): JSX.Element {
  const t = useT();
  return (
    <Chip tone={SOURCE_TONE[source]} lamp={source !== 'none' && source !== 'global'} testId={testId}>
      {t(SOURCE_KEY[source])}
    </Chip>
  );
}

export function formatCap(value: number | null | undefined, unlimited: string): string {
  return typeof value === 'number' ? value.toLocaleString() : unlimited;
}
